import { IMG } from "../data";

const items = [
  {
    title: "Picos de Europa National Park",
    eyebrow: "Mountains",
    text: "Dramatic limestone peaks, glacial lakes and ancient forests. Hike through the Cares Gorge, spot Iberian wolves and chamois, and let the silence of the high meadows reset your sense of pace.",
    img: IMG.picosDeEuropa,
    icon: "fa-mountain-sun",
  },
  {
    title: "The Cantabrian Coast",
    eyebrow: "Sea & Cliffs",
    text: "Wild Atlantic beaches, hidden coves and seafood grilled within hours of being landed. Drive the coast road from Llanes to San Vicente de la Barquera and taste the freshness on every plate.",
    img: IMG.cantabrianCoast,
    icon: "fa-water",
  },
  {
    title: "Basque Culture & Pintxos",
    eyebrow: "Food & Heritage",
    text: "An hour east, the Basque Country awaits. Wander Bilbao's old town, hop between pintxos bars in San Sebastián, and discover one of the most decorated culinary regions in the world.",
    img: IMG.pintxos,
    icon: "fa-utensils",
  },
  {
    title: "San Juan de Gaztelugatxe",
    eyebrow: "Iconic",
    text: "A tiny island church reached by 241 stone steps along a serpentine causeway. The view at the top — Cantabrian waves crashing against jagged cliffs — feels like a chapter from another century.",
    img: IMG.gaztelugatxe,
    icon: "fa-place-of-worship",
  },
  {
    title: "Stone Villages & Local Markets",
    eyebrow: "Slow Travel",
    text: "Forget itineraries. Spend mornings in centuries-old stone villages, browse Saturday markets for local cheese, cider and chorizo, and let the rhythm of village life guide your day.",
    img: IMG.stoneVillage,
    icon: "fa-store",
  },
];

export default function ThingsToDo() {
  return (
    <main data-testid="things-to-do-page" style={{ background: "var(--cream)" }}>
      {/* HERO */}
      <section className="pt-40 pb-20 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: `url(${IMG.greenValley})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
        <div className="container-cu relative z-10 text-center max-w-3xl mx-auto">
          <p className="eyebrow mb-6">Travel Guide</p>
          <h1 className="heading-display text-5xl sm:text-6xl lg:text-7xl mb-6">
            Discover <span className="heading-italic">Northern Spain</span>
          </h1>
          <p className="text-lg leading-relaxed" style={{ color: "var(--brown-soft)" }}>
            Mountains, coast, culture and cuisine — all within reach.
          </p>
        </div>
      </section>

      {/* ITEMS */}
      <section className="pb-20">
        <div className="container-cu space-y-20">
          {items.map((it, i) => {
            const reverse = i % 2 === 1;
            return (
              <article
                key={it.title}
                className="grid lg:grid-cols-12 gap-10 items-center"
                data-testid={`thing-${i}`}
              >
                <div className={`lg:col-span-7 ${reverse ? "lg:order-2" : ""}`}>
                  <div className="aspect-[16/10] overflow-hidden rounded-md">
                    <img
                      src={it.img}
                      alt={it.title}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000"
                    />
                  </div>
                </div>
                <div className={`lg:col-span-5 ${reverse ? "lg:order-1" : ""}`}>
                  <div className="flex items-center gap-3 mb-5">
                    <span
                      className="w-10 h-10 inline-flex items-center justify-center rounded-md"
                      style={{ background: "var(--cream-deep)", color: "var(--forest)" }}
                    >
                      <i className={`fa-solid ${it.icon}`}></i>
                    </span>
                    <p className="eyebrow">{it.eyebrow}</p>
                  </div>
                  <h2 className="heading-display text-3xl sm:text-4xl mb-5">{it.title}</h2>
                  <p className="text-base leading-relaxed" style={{ color: "var(--brown-soft)" }}>
                    {it.text}
                  </p>
                  <div className="mt-8 inline-flex items-center gap-3 text-xs uppercase tracking-[0.22em]" style={{ color: "var(--gold-deep)" }}>
                    <span className="w-8 h-px" style={{ background: "var(--gold)" }}></span>
                    {String(i + 1).padStart(2, "0")} / {String(items.length).padStart(2, "0")}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      {/* FOOTER NOTE */}
      <section className="section" style={{ background: "var(--cream-deep)" }}>
        <div className="container-narrow text-center">
          <p className="eyebrow mb-5">A Region to Return To</p>
          <h2 className="heading-display text-3xl sm:text-4xl mb-6">
            "Northern Spain doesn't shout. It <span className="heading-italic">whispers</span>."
          </h2>
          <p className="text-base leading-relaxed max-w-xl mx-auto" style={{ color: "var(--brown-soft)" }}>
            Once you've walked its trails, tasted its food and listened to its
            mountains, you understand why guests don't leave Casa Haya —
            they simply plan their return.
          </p>
        </div>
      </section>
    </main>
  );
}
